/********************************************************************
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this
 * file in accordance with the terms of the Adobe license agreement
 * accompanying it.
 *******************************************************************/

import { FetchGraphQL } from '@adobe-commerce/fetch-graphql';

export const {
  setEndpoint,
  setFetchGraphQlHeader,
  removeFetchGraphQlHeader,
  setFetchGraphQlHeaders,
  getFetchGraphQlHeader,
  fetchGraphQl,
  getConfig,
} = new FetchGraphQL().getMethods();
